import { render, staticRenderFns } from "./project_form_group.vue?vue&type=template&id=5c2888e7"
import script from "./project_form_group.vue?vue&type=script&lang=js"
export * from "./project_form_group.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports